import React from 'react';

const NotificationBellIcon = ({ className }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M18 8.5C18 5.18629 15.3137 2.5 12 2.5C8.68629 2.5 6 5.18629 6 8.5V12.2117C6 13.0423 5.68403 13.8418 5.11612 14.448L4.64188 14.9545C3.86939 15.7795 4.45434 17.125 5.58112 17.125H18.4189C19.5457 17.125 20.1306 15.7795 19.3581 14.9545L18.8839 14.448C18.316 13.8418 18 13.0423 18 12.2117V8.5Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 18.5C9.85218 19.6816 10.9465 20.5 12.2 20.5C13.4535 20.5 14.5478 19.6816 14.9 18.5"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
    />
  </svg>
);

export default NotificationBellIcon;
